import Vue from 'vue'
import moment from 'moment-timezone'

function toFixed(num, precision) {
  return (+(Math.round(+(num + 'e' + precision)) + 'e' + -precision)).toFixed(precision);
}

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  const arr = value.split(' ')
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('k_formatter', function (num) {
  return Math.abs(num) > 999 ? `${ toFixed((num / 1000), 1) }k` : toFixed(num, 1)
})

Vue.filter('M_formatter', function (num) {
  return  Math.abs(num) > 999999 ? `${ toFixed((num / 1000000), 1) }M` : toFixed(num, 1)
})

Vue.filter('KPI_M_k_formatter', function (num) {
  return  Math.abs(num) > 999999 ? `${ toFixed((num / 1000000), 1) }M` : Math.abs(num) > 999 ? `${ toFixed((num / 1000), 1) }k` : toFixed(num, 1)
})

Vue.filter('toPercentage', function (value) {
  if (typeof value === 'undefined') {
    return value;
  }
  if (value === null) {
    return null;
  }

  if (isNaN(value)) {
    return null;
  }

  let f = value

  if (f > -0.01 && f < 0.01)
    f = 0;
  
  return toFixed(parseFloat(f), 2) + " %";
})


Vue.filter('toIntPercentage', function (value) {
  if (typeof value === 'undefined') {
    return value;
  }
  if (value === null) {
    return null;
  }

  if (isNaN(value)) {
    return null;
  }
  
  return toFixed(parseFloat(value), 0) + " %";
})

Vue.filter('toDate', function (value) {
  if (value) {
    return moment(new Date(value)).format('YYYY-MM-DD')
  }
})

Vue.filter('toTime', function (value) {
  if (value) {
    return moment(new Date(value)).format('HH:mm:ss')
  }
})

Vue.filter('toDateTime', function (value) {
  if (value) {
    moment.tz.guess()
    const date = moment(new Date(value)).format('YYYY-MM-DD HH:mm:ss')
   
    return date
  }
})

Vue.filter('toLocalDateTime', function (value) {
  if (value) {
    moment.tz.guess()
    const date = moment(new Date(value) + "Z").format('YYYY-MM-DD HH:mm:ss')
   
    return date
  }
})

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  });
  return formatter.format(value);
})

Vue.filter('toCurrencyDecimal', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  });
  return formatter.format(value);
})

Vue.filter('toMRMRTonnage', function (value) {
  if (typeof value === 'undefined') {
    return value;
  }
  if (value === null) {
    return null;
  }

  let f = parseFloat(value);

  if (f > -0.01 && f < 0.01)
    f = 0;

  return Math.round(f).toLocaleString('en-US');
})

Vue.filter('toFriendlyTonnage', function (value) {
  if (typeof value === 'undefined') {
    return null;
  }
  if (value === null || value === '') {
    return toFixed(parseFloat(0), 2);
  }
  return toFixed(parseFloat(value), 2);
})

Vue.filter('toFriendlyGrade', function (value) {
  if (typeof value === 'undefined') {
    return null;
  }
  if (value === null || value === '') {
    return toFixed(parseFloat(0), 2);
  }
  return toFixed(parseFloat(value), 2);
})

Vue.filter('toFriendlyDiffGrade', function (value) {
  if (typeof value === 'undefined') {
    return null;
  }
  if (value === null || value === '') {
    return toFixed(parseFloat(0), 2);
  }

  let f = parseFloat(value);

  if (f > -0.0001 && f < 0.0001)
    f = 0;


  return toFixed(f, 2);
})

Vue.filter('toFriendlyDensity', function (value) {
  if (typeof value === 'undefined') {
    return "ρ : n/a"
  }
  if (value === null || value === '') {
    return "ρ : " + toFixed(parseFloat(0), 2);
  }
  return "ρ : " + toFixed(parseFloat(value), 2);
})

Vue.filter('toInteger', function (value) {
  if (typeof value === 'undefined') {
    return value;
  }
  if (value === null) {
    return null;
  }
  return parseFloat(value).toFixed(0);
})

Vue.filter('toFormattedCuringDays', function (breakingDate, sampleTakenTime) {
  if (breakingDate) {
    const val1 = moment(breakingDate);
    const val2 = moment(sampleTakenTime);
    const duration = moment.duration(val1.diff(val2));
    return duration.get("days").toString().concat("d ", duration.get("hours"), "h ", duration.get("minutes"), "min");  
  }
  return null;
})

Vue.filter('toFriendlyNumber', function (value) {
  return new Intl.NumberFormat('fr-CA').format(value);
})

Vue.filter('toFixedIfDecimal', function (value) {
  const v = parseFloat(value);
  return v.toFixed(2) % 1 === 0 ? v.toFixed(0) : v.toFixed(2);
})
